import React, { Component, useRef } from "react";
import Switch from "react-switch";
import axios from "axios";
// import * as io from "socket.io-client";
import io from "socket.io-client";
import "../../styles/App.css";
import { InputLabel, Select, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MomentInput from "react-moment-input";
import moment from "moment";
import Typography from "@material-ui/core/Typography";

///////////////////////////////////////////////////////////////////////////////////

// const classes = useStyles();
// var mqtt = require("mqtt");
// // var host = "ws://192.168.0.199:3000";
// var host = "ws://192.168.0.199:3000";
// var options = {
//   keepalive: 3600,
//   protocolId: "MQTT",
//   protocolVersion: 4,
//   clean: true,
//   reconnectPeriod: 1000,
//   connectTimeout: 30 * 1000,
//   will: {
//     topic: "WillMsg",
//     payload: "Connection Closed abnormally..!",
//     qos: 0,
//     retain: false,
//   },
//   username: "",
//   password: "",
//   rejectUnauthorized: false,
// };
// var mqttClient = mqtt.connect(host, options);

// const MQTT = require("async-mqtt");
// // const client = MQTT.connect("tcp://192.168.0.199:3000");
// const client = MQTT.connect("tcp://192.168.0.199:3000");

class TimePicker extends Component {
  constructor(props) {
    // console.log(props.topic + " : " + props.message);
    super(props);
    this.state = {
      DefaultChecked: props.message,
      checked: "not yet",
      flag: false,
      topic: props.topic,
      currentMode: "0",
      changeModeTo: "",
      time: "",
    };
    this.handleOnSave = this.handleOnSave.bind(this);
  }

  handleOnSave = (time) => {
    let timeConv = time._i.split(":");
    let seconds = +timeConv[0] * 60 * 60 + +timeConv[1] * 60 + +timeConv[2];
    // mqttClient.publish(
    //   "hamk/iot/valkeakoski/kontti/ui/" +
    //     this.state.topic ,
    //   seconds.toString()
    // );
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.time !== this.state.time) {
      this.setState({ flag: true });
      console.log(this.state.time);
    }
  }

  render() {
    return (
      <label>
        <div
        >
          <MomentInput
            format="HH:mm:ss"
            monthSelect={false}
            options={true}
            readOnly={false}
            icon={true}
            tab={1}
            options={false}
            onSave={this.handleOnSave}
          />
          <Typography id="range-slider" gutterBottom>
            <p>Currently: T#{this.props.currentTime}</p>
          </Typography>
        </div>
      </label>
    );
  }
}

export default TimePicker;
